import axios, { AxiosResponse } from "axios";

const MAX_RETRIES = 5;
const BASE_DELAY_MS = 1000;

export async function fetchWithRetry<T>(
  url: string,
  body: Record<string, unknown>,
  maxRetries = MAX_RETRIES,
): Promise<AxiosResponse<T>> {
  let lastError: unknown;

  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      return await axios.post<T>(url, body);
    } catch (error) {
      lastError = error;
      if (attempt < maxRetries - 1) {
        const delay = BASE_DELAY_MS * Math.pow(2, attempt); // 1s, 2s, 4s, 8s, 16s
        await new Promise((r) => setTimeout(r, delay));
      }
    }
  }

  throw lastError;
}
